import type { CartItemStyle } from 'types/graphql/website/__generated__/graphql'
import { formatCost, formatNumbers } from 'utils'

type Props = {
	style: CartItemStyle & {
		totalPrice: number
	}
}

export default function CartItemStyleSummary({ style }: Props) {
	return (
		<div className="w-full flex justify-between items-center">
			<div className="flex items-center gap-2">
				<span className="truncate max-w-[120px]">{style.style.fullName}</span>

				<span>
					{style.color.name} ({formatNumbers(style.quantity)})
				</span>
			</div>

			{/* Price */}
			<span className="text-sm">{formatCost(style.totalPrice)}</span>
		</div>
	)
}
